import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const ImageModal = ({ isOpen, onClose, imageUrl, imageAlt }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-10 p-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full transition-colors"
      >
        <X className="w-6 h-6 text-white" />
      </button>

      {/* Image Container */}
      <div className="relative w-full h-full flex items-center justify-center">
        <img
          src={imageUrl}
          alt={imageAlt}
          className="max-w-full max-h-full object-contain"
          draggable={false}
        />
      </div>

      {/* Instructions */}
      <div className="absolute bottom-4 right-4 z-10 bg-white bg-opacity-20 px-3 py-1 rounded-full">
        <span className="text-white text-xs">
          ESC для закрытия
        </span>
      </div>
    </div>
  );
};

export default ImageModal; 